module.exports = __webpack_public_path__ + "img/fzp.168852f7.jpg";